import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  type TResolvedTheme,
  type TThemeMode,
  getStoredThemeMode,
  resolveTheme
} from '@/shared/services/theme';

const initialThemeMode = getStoredThemeMode();

const initialState: IAppState = {
  headerConfig: {
    showElements: {
      header: true,
      langSelector: true,
      notifications: true
    },
    title: '',
    subtitle: '',
    helmetTitle: ''
  },
  isLoading: 0,
  // themeMode — выбор пользователя; theme — эффективная схема (для system из matchMedia).
  themeMode: initialThemeMode,
  theme: resolveTheme(initialThemeMode)
};

export type TAppState = typeof initialState;

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setHeaderConfig: (
      state,
      action: PayloadAction<Partial<IAppState['headerConfig']>>
    ) => {
      state.headerConfig = {
        ...initialState.headerConfig,
        ...action.payload,
        showElements: {
          ...initialState.headerConfig.showElements,
          ...(action.payload.showElements ?? {})
        }
      };
    },
    startLoading: (state) => {
      state.isLoading++;
    },
    stopLoading: (state) => {
      state.isLoading--;
      if (state.isLoading < 0) {
        state.isLoading = 0;
      }
    },
    resetLoading: (state) => {
      state.isLoading = 0;
    },
    /** Сменить режим темы (выбор пользователя) + сразу эффективную схему. */
    setThemeMode: (
      state,
      action: PayloadAction<{ mode: TThemeMode; theme: TResolvedTheme }>
    ) => {
      state.themeMode = action.payload.mode;
      state.theme = action.payload.theme;
    },
    /** Обновить только эффективную схему (например, при смене системной темы в режиме system). */
    setTheme: (state, action: PayloadAction<TResolvedTheme>) => {
      state.theme = action.payload;
    }
  }
});

export const {
  setHeaderConfig,
  startLoading,
  stopLoading,
  resetLoading,
  setThemeMode,
  setTheme
} = appSlice.actions;
export default appSlice;

interface IAppState {
  headerConfig: {
    title: string;
    subtitle: string;
    helmetTitle: string;
    showElements: {
      header?: boolean;
      langSelector?: boolean;
      notifications?: boolean;
      closeService?: boolean;
    };
  };
  isLoading: number;
  themeMode: TThemeMode;
  theme: TResolvedTheme;
}
